export enum MissionTrackingEventName {
    missionStarted = 'missionStarted',
    missionFailed = 'missionFailed',
    missionCompleted = 'missionCompleted',
}

export enum TrackingEventName {
    newPlayer = 'newPlayer',
    gameStarted = 'gameStarted',
}

export enum TransactionTrackingEventName {
    transaction = 'transaction',
    resource = 'resource',
}

export enum AdTrackingEventName {
    adRequest = 'adRequest',
}

export type allTrackingEvents =
    | MissionTrackingEventName
    | TransactionTrackingEventName
    | AdTrackingEventName
    | TrackingEventName;
